<template>
  <div
    class="menubutton"
    :class="{ 'menubutton-opend': isOpened }"
    @click="openNavigation"
  >
    <span></span>
  </div>
</template>

<script>
export default {
  name: 'MenuButton',
  data() {
    return {
      isOpened: false
    };
  },
  methods: {
    openNavigation() {
      this.isOpened = !this.isOpened;
      this.$emit('openNavigation', this.isOpened);
    }
  }
};
</script>

<style lang="scss" scoped>
.menubutton {
  display: block;
  padding: 15px;
  background: inherit;
  cursor: pointer;
  span {
    background: $text-dark;
    display: block;
    width: 18px;
    height: 2px;
    margin: auto;
    position: relative;
    transition: 0.3s;
    &::before,
    &::after {
      content: '';
      background: $text-dark;
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      transition: 0.3s;
    }
    &::before {
      top: 5px;
    }
    &::after {
      top: -5px;
    }
  }
}

.menubutton-opend {
  span {
    background: transparent;
    &::before {
      transform: rotate(-45deg);
      top: 0;
    }
    &::after {
      transform: rotate(45deg);
      top: 0;
    }
  }
}
</style>
